<template>
  <div class="step-container-wrapper">
   <div class="step-container" v-if="isDisplay">
     <div class="circle" :class="{'active': current === 1}" @click="clickWizardDot1">
        <div class="step-number-label" :class="{'active-number-label': current === 1}">
          1
        </div>
        <div class="step-label" :class="{'active-label': current === 1}">
          プロフィール
        </div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div class="circle" 
          :class="{
            'active': current === 2,
            'disable': $store.state.validations.userInfo === true
          }"
          @click="clickWizardDot2"
     >
       <div class="step-number-label" :class="{'active-number-label': current === 2}">
         2
       </div>
       <div class="step-label" :class="{'active-label': current === 2}">
        身体情報・病歴
       </div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div
        class="circle"
        :class="{
            'active': current === 3,
            'disable': $store.state.validations.userInfo
            || $store.state.validations.physicalInfo === true
        }"
        @click="clickWizardDot3"
      >
       <div class="step-number-label" :class="{'active-number-label': current === 3}">
         3
        </div>
       <div class="step-label" :class="{'active-label': current === 3}">
         家族の病歴
       </div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div
        class="circle"
        :class="{
            'active': current === 4,
            'disable': $store.state.validations.userInfo
            || $store.state.validations.physicalInfo === true
        }"
        @click="clickWizardDot4"
      >
       <div class="step-number-label" :class="{'active-number-label': current === 4}">
         4
       </div>
       <div class="step-label" :class="{'active-label': current === 4}">
         血液検査結果
       </div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div
        class="circle"
        :class="{
            'active': current === 5,
            'disable': $store.state.validations.userInfo
            || $store.state.validations.physicalInfo
            || $store.state.validations.bloodTestResult === true
        }"
        @click="clickWizardDot5"
      >
       <div class="step-number-label" :class="{'active-number-label': current === 5}">
         5
       </div>
       <div class="step-label" :class="{'active-label': current === 5}">生活習慣</div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div
        class="circle"
        :class="{
            'active': current === 6,
            'disable': $store.state.validations.userInfo
            || $store.state.validations.physicalInfo
            || $store.state.validations.bloodTestResult
            || $store.state.validations.lifeStyle === true
        }"
        @click="clickWizardDot6"
      >
       <div class="step-number-label" :class="{'active-number-label': current === 6}">
         6
       </div>
       <div class="step-label" :class="{'active-label': current === 6}">入力内容の確認</div>
     </div>
     <div class="triangle-area">
       <div class="triangles">
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
        <div class="triangle"/>
       </div>
     </div>

     <div class="purchaseLabel-container">
        <div class="purchaseProcess-label">{{ $t('stepText.purchaseProcess') }}</div>
     </div>
   </div>
  </div>
</template>

<script>
import VueTypes from "vue-types";
import _ from 'lodash'

export default {
  props: {
    current: VueTypes.number.isRequired,
    isDisplay: VueTypes.bool.isRequired
  },
  methods: {
    clickWizardDot1() {
      // $emitでtoggleCurrentを呼び出す
      this.$emit("toggleCurrent", 1);
    },
    clickWizardDot2() {
      if (!this.$store.state.validations.userInfo) {
        this.$emit("toggleCurrent", 2);
      }
    },
    clickWizardDot3() {
      if (
        !this.$store.state.validations.userInfo &&
        !this.$store.state.validations.physicalInfo
      ) {
        this.$emit("toggleCurrent", 3);
      }
    },
    clickWizardDot4() {
      if (
        !this.$store.state.validations.userInfo &&
        !this.$store.state.validations.physicalInfo
      ) {
        this.$emit("toggleCurrent", 4);
      }
    },
    clickWizardDot5() {
      if (
        !this.$store.state.validations.userInfo &&
        !this.$store.state.validations.physicalInfo &&
        !this.$store.state.validations.bloodTestResult
      ) {
        this.$emit("toggleCurrent", 5);
      }
    },
    clickWizardDot6() {
      if (
        !this.$store.state.validations.userInfo &&
        !this.$store.state.validations.physicalInfo &&
        !this.$store.state.validations.bloodTestResult &&
        !this.$store.state.validations.lifeStyle
      ) {
        this.$emit("toggleCurrent", 6);
      }
    },
  },
};
</script>


<style scoped>
.step-container-wrapper{
  align-content: center;
  align-items: center;
  margin: 0 auto;
}
.step-container {
  display: flex;
  margin-right: auto;
  margin-left: auto;
}
.active {
  background-color: #429be1 !important;
}
.active-number-label {
  color: white !important;
}
.active-label {
  font-weight: bold;
  color: #444444 !important; 
}
.circle {
  background-color: #c4d7ef;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  overflow: visible;
}
.step-number-label {
  color: #555555;
  font-size: 26px;
  font-weight: bold;
  line-height: 46px;
}
.step-label {
  /* display: inline-block; */
  /* float: left; */
  color: #aaaaaa;
  width: 120px;
  height: 20px;
  position: relative;
  left: -85%;
  bottom: -25%;
  z-index: -1;
}
.triangle-area {
  margin-left: 10px;
}
.triangles {
  display: flex;
  position: relative;
  top: 12px;
  z-index: -1;
  justify-content: center;
}
.triangle {
  width: 0;
  height: 0;
  border: 0.7vw solid transparent;
  border-left: 0.7vw solid #c4d7ef;
}
.purchaseLabel-container {
  width: 70px;
}
.purchaseProcess-label {
  color: #429be1;
  width: 70px;
  line-height: 20px;
  font-weight: bold;
  position: relative;
  top: 10%;
  z-index: -1;
}
</style>
